<ng-container *ngIf="moduleManager.settingsView === 'cxOneModal'">
    <div class="form-group" cvModuleCxoneCustomSettingSection position="top" [moduleManager]="moduleManager">
        <p cvLocalizedText langSection="CXOne_Call_Arrival_Module" langKey="Contact_Arrival" class="cxone-section-header">
            Contact Arrival</p>
        <div class="container inputs-section">
            <div class="row">
                <div class="d-flex">
                    <div class="flex-fill d-flex flex-column">
                        <label cvLocalizedText langSection="CXOne_Call_Arrival_Module" langKey="Hours">Hours</label>
                        <div id="numeric-selector" style="display: flex;">
                            <cxone-numeric-selector [(ngModel)]="hourInterval" [step]="1" [min]="1" [max]="72">
                            </cxone-numeric-selector>
                            <span class="hours_description" cvLocalizedText langSection="CXOne_Call_Arrival_Module"
                                langKey="Hours_Before_To"> hours before to</span>
                        </div>
                    </div>
                    <div id="datetime-picker" class="flex-fill d-flex flex-column datetime-picker-container">
                        <label cvLocalizedText langSection="CXOne_Call_Arrival_Module" langKey="Date">Date</label>
                        <cxone-combined-datetime-picker [(ngModel)]="dataValue" (ngModelChange)="dateValueChanged($event)" [mode]="mode" [minDate]="minDate"
                            [maxDate]="maxDate" [shortDateTimeFormat]="'MMM D, YYYY h:mm A'" [removeShadows]="true" [datetimePickerContainer]="'.datetime-picker-container'">
                        </cxone-combined-datetime-picker>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>